import React, {FC} from "react";
import {Box, makeStyles} from "@material-ui/core";
import pdfIcon from "../images/Icons/pdf_icn.svg";
import Text from "./Text";
import GradientButton from "./GradientButton";
import {I18n} from "aws-amplify";
// @ts-ignore
import begleitschreibenDE from "../Begleitschreiben_AnkaufperPost_DE.pdf";
// @ts-ignore
import begleitschreibenAT from "../Begleitschreiben_AnkaufperPost_AT.pdf";
import {useGlQueryParam} from "../wizard/slideRouter/queryParamHook";

const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        paddingTop: 60,
        [theme.breakpoints.down("sm")]: {
            paddingTop: 43
        }
    },
    icon: {
        marginBottom: 7
    },
    buttonContainer: {
        marginTop: 15
    }
}));

const PostalHint: FC = () => {
    const classes = useStyles();

    const {countryCode} = useGlQueryParam();

    return (
        <Box className={classes.container}>
            <img src={pdfIcon} alt={"pdf"} className={classes.icon}/>
            <Text
                value={"Alternativ Begleitschreiben ausfüllen."}
                size={14}
                centered
            />
            <Box className={classes.buttonContainer}>
                <GradientButton
                    text={I18n.get("downloadButton")}
                    onClick={() => window.open(countryCode === "DE" ? begleitschreibenDE : begleitschreibenAT, "_blank")}
                />
            </Box>
        </Box>
    );
};

export default PostalHint;
